import React from 'react';
import {Form} from 'antd';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import styled from 'styled-components';
import ENDPOINTS from '../../../constants/endpoints';
import api from '../../../services/api';
import {BASE_ENDPOINT} from '../../../settings';

const EditorWrapper = styled.div`
    .ck-editor__editable {
        min-height: ${props => props.$minHeight || '300px'};
    }

    .ck-editor__editable:focus {
        border-color: #40a9ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
`;

class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(async file => {
            const formData = new FormData();
            formData.append('upload', file);

            try {
                const response = await api.post(ENDPOINTS.CKEDITOR_UPLOAD, formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                });

                if (response.data.url) {
                    const imageUrl = response.data.url.startsWith('http')
                        ? response.data.url
                        : `${BASE_ENDPOINT}${response.data.url}`;
                    return {default: imageUrl};
                } else {
                    throw new Error(response.data.error?.message || 'Upload failed');
                }
            } catch (error) {
                throw error.response?.data?.message || error.message || 'Upload failed';
            }
        });
    }

    abort() {
        // Abort upload if needed
    }
}

function uploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new UploadAdapter(loader);
    };
}

export default function RichTextFormField({form, minHeight, ...props}) {
    return (
        <Form.Item {...form}>
            <RichTextEditor minHeight={minHeight} {...props} />
        </Form.Item>
    );
}

function RichTextEditor({value, onChange, minHeight, placeholder}) {
    return (
        <EditorWrapper $minHeight={minHeight}>
            <CKEditor
                editor={ClassicEditor}
                data={value || ''}
                config={{
                    language: 'pt-br',
                    placeholder: placeholder || 'Digite o conteúdo aqui...',
                    extraPlugins: [uploadAdapterPlugin],
                    heading: {
                        options: [
                            {
                                model: 'heading1',
                                view: 'h1',
                                title: 'Título 1',
                                class: 'ck-heading_heading1'
                            },
                            {
                                model: 'heading2',
                                view: 'h2',
                                title: 'Título 2',
                                class: 'ck-heading_heading2'
                            },
                            {
                                model: 'heading3',
                                view: 'h3',
                                title: 'Título 3',
                                class: 'ck-heading_heading3'
                            },
                            {
                                model: 'heading4',
                                view: 'h4',
                                title: 'Título 4',
                                class: 'ck-heading_heading4'
                            },
                            {
                                model: 'paragraph',
                                title: 'Parágrafo',
                                class: 'ck-heading_paragraph'
                            },

                        ]
                    },
                    toolbar: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        '|',
                        'imageUpload',
                        'blockQuote',
                        'insertTable',
                        'mediaEmbed',
                        '|',
                        'undo',
                        'redo'
                    ],
                    image: {
                        toolbar: [
                            'imageTextAlternative',
                            'imageStyle:inline',
                            'imageStyle:block',
                            'imageStyle:side'
                        ]
                    },
                    table: {
                        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                    }
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    onChange?.(data);
                }}
            />
        </EditorWrapper>
    );
}
